import { useSelector } from 'react-redux';
import { MAX_ACCOUNTS } from '../constants/accounts';

/** Signed-in accounts and whether the multi-account cap is reached (#168). */
export const useAccountCap = () => {
	const accounts = useSelector((st) => st.user.accounts) || [];
	return { accounts, atCap: accounts.length >= MAX_ACCOUNTS };
};

export default useAccountCap;
